<template>
  <modal-provider
    :fullscreen-breakpoint="1100"
    name="comment-photo-modal"
    :width="1800"
    @before-open="beforeOpen"
    @opened="opened"
  >
    <template v-slot:modal-heading>
      <header v-if="commentsLoaded" class="photo-modal__header">
        <h2 class="photo-modal__title block-ellipsis block-ellipsis-truncate">
          {{ computedTitle }}
        </h2>
      </header>
    </template>
    <div class="photo-modal__container" v-if="commentsLoaded">
      <div class="photo-modal__body">
        <div class="photo-modal__slider-container">
          <PhotoSlider
            is-modal
            is-comment-gallery
            :media="currentType.media"
            :is-questions="isQuestions"
            :current-photo-index="currentIndex" />
        </div>
        <ul class="photo-modal__comment-container custom-scrollbar">
          <CommentItem
            :comment="currentComment"
            :endpoint="endpoint"
            :product-id="productId"
            is-comment-modal />
        </ul>
      </div>
    </div>
  </modal-provider>
</template>

<script>
import { mapState } from 'vuex'
import PhotoSlider from '@/components/product/product-page/photo-gallery/PhotoSlider'
import CommentItem from './CommentItem'

export default {
  name: 'CommentPhotoModal',
  data () {
    return {
      currentIndex: 0,
      endpoint: '',
      productId: null,
      isQuestions: false
    }
  },
  components: {
    PhotoSlider,
    CommentItem
  },
  computed: {
    ...mapState({
      title: state => state.productInfo.productInfo.title,
      comments: state => state.comments.commentsWithMedia,
      questions: state => state.questions.commentsWithMedia,
      currentMediaIndex: state => state.comments.currentMediaIndex,
      currentMediaQuestionIndex: state => state.questions.currentMediaIndex
    }),
    currentType () {
      return this.isQuestions ? this.questions : this.comments
    },
    currentTypeIndex () {
      return this.isQuestions ? this.currentMediaQuestionIndex : this.currentMediaIndex
    },
    commentsLoaded () {
      return !!Object.keys(this.currentType).length
    },
    currentMediaCommentId () {
      if (this.commentsLoaded && this.currentType.media[this.currentTypeIndex]) {
        return this.currentType.media[this.currentTypeIndex].comment_id
      }
      return null
    },
    currentComment () {
      if (this.commentsLoaded) {
        return this.currentType.comments[this.currentMediaCommentId]
      }
      return null
    },
    computedTitle () {
      return this.title || this.$t('comments_with_photo')
    }
  },
  methods: {
    beforeOpen (event) {
      this.endpoint = event.params?.endpoint ? event.params.endpoint : ''
      this.productId = event.params?.productId ? event.params.productId : null
      this.isQuestions = event.params?.isQuestions || false

      if (event.params && event.params.data) {
        for (let i = 0; i < this.currentType.media.length; i++) {
          if (
            this.currentType.media[i].origin_photo === event.params.data ||
            this.currentType.media[i].video_id === event.params.data
          ) {
            this.currentIndex = i
            break
          }
        }
      }
    },
    opened () {
      window.dispatchEvent(new Event('resize'))
    }
  }
}
</script>

<style scoped lang="sass">

:v-deep()
  padding: 0
  .modal-heading
    border-bottom: 1px solid #E7E7E7
  .modal-body
    padding: 0

.photo-modal__container
  height: 100%
  width: 100%

.photo-modal__body
  display: flex
  flex-direction: column
  position: relative
  width: 100%
  padding: 20px 15px

  +mmin($tablet--hor)
    flex-direction: row
    align-items: flex-start
    padding: 20px 60px 40px 40px

  +mmax(1100)
    padding-bottom: 100px

.photo-modal__slider-container
  width: 100%
  +mmin($tablet--hor)
    max-height: 690px
    width: 59%
    margin: auto

.photo-modal__comment-container
  +list-unstyled
  width: 100%
  margin: 30px 0 0

  +mmin($tablet--hor)
    width: 41%
    margin: 0 0 0 40px

  +mmin($tablet--hor)
    max-height: 690px
    overflow-y: auto

.photo-modal__title
  font-size: 18px
  font-weight: 500
  margin: 0
  -webkit-box-orient: vertical
  -webkit-line-clamp: 1

  +mmin($tablet--hor)
    font-size: 24px
</style>
